module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-up-square-fill-899bf7b0.svg";